import { combineReducers } from "redux";

import eventFetch from "./event-fetch.reducer";
import eventSave from "./event-save.reducer";

export default combineReducers({
  eventFetch,
  eventSave,
});
